export default function Home() {
  return (
    <>
      <div class="h-[93vh] md:h-[100vh] bg-black">
        <div class="text-white flex justify-center flex-col w-full h-full">
          <div class="m-auto flex flex-col justify-center">
            <h1 class="text-3xl md:text-7xl m-auto p-2 font-bold">
              (pls, bro)
            </h1>
            <p class="text-xl m-auto text-gray-600">
              {"<"}A series of blockchain experiments{"/>"}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
